export default [
  {
    path: '/records/sme/ticket/list',
    name: 'smeTicketList',
    component: () => import('@/views/records/sme/list'),
    meta: {
      keepAlive: false,
      bg_white: true
    }
  },
  {
    path: '/sme/tickets/detail',
    name: 'smeTicketsDetail',
    // component: () => import('@/views/tickets/detail'),
    component: () => import('@/views/sme/detail'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/create/sme/:severType/tickets/:classId',
    name: 'CreateSMETicket',
    component: () => import('@/views/sme/create-sme-ticket'),
    meta: {
      keepAlive: false
    }
  },
]
